import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const industry = z
    .union([
    z.literal("Agriculture"),
    z.literal("Apparel"),
    z.literal("Cannabis"),
    z.literal("Coffee & Tea"),
    z.literal("Confectionary"),
    z.literal("Construction"),
    z.literal("Dairy"),
    z.literal("Entertainment"),
    z.literal("Food"),
    z.literal("Frozen Foods"),
    z.literal("Granola & Cereals"),
    z.literal("Health & Organics"),
    z.literal("Industrial & Household Chemicals"),
    z.literal("Liquids & Beverages"),
    z.literal("Other"),
    z.literal("Pet food & Treats"),
    z.literal("Pharmaceutical"),
    z.literal("Snacks"),
    z.literal("Sports & Fitness"),
])
    .describe(createCustomSettings({ isRadioList: true, label: "Industry" }));
export const industryLookup = {
    "1": "Cannabis",
    "2": "Entertainment",
    "3": "Frozen Foods",
    "4": "Granola & Cereals",
    "5": "Pet food & Treats",
    "6": "Food",
    "10": "Dairy",
    "11": "Liquids & Beverages",
    "12": "Industrial & Household Chemicals",
    "14": "Apparel",
    "15": "Snacks",
    "16": "Construction",
    "18": "Coffee & Tea",
    "19": "Confectionary",
    "21": "Sports & Fitness",
    "22": "Health & Organics",
    "24": "Pharmaceutical",
    "74": "Agriculture",
    "83": "Other",
};
//# sourceMappingURL=industries-list.js.map